import React, { useContext, useEffect, useState } from 'react';
import KhAlert from '../../Components/Alert/KhAlert';
import { UserInfokh } from '../../Contexts/UserContext';
import axios from 'axios';
import { ApiURL } from '../../App';
import { useNavigate } from 'react-router-dom';

const AddPayment = () => {

    const queryParameters = new URLSearchParams(window.location.search);  // to get RepositoryId form url
    const EntitlementId = queryParameters.get("EntitlementId"); 
    const supplierName = queryParameters.get("supplierName"); 

    const userInfo_Now =useContext(UserInfokh);
    const [alert_,SetAlert]=useState({Activate:false,msg:''});
    const [flag,Setflag]=useState(false);
    const navigate =useNavigate();
    const [formData, setFormData] = useState({
        entitlementId: EntitlementId,
        amountPayment: '',
        paymentDate: '',
        notes: ''
      });
   
      const handleChange = (name, value) => {
        setFormData({
          ...formData,
          [name]: value
        });        
      };

      const handleSubmit = async (e) => {
        Setflag(true);
        if(!(formData.amountPayment<0.01 ||formData.paymentDate.length<1))
        {
          try {
          const res = await axios.post(ApiURL+'FinancialPayments/AddFinancialPayment', formData, {
            headers: {
              'Accept': 'text/plain',
              'Content-Type': 'application/json',
               'Authorization': `bearer ${userInfo_Now.auth.token}`
            }
           
          });
          navigate('/Payments?EntitlementId='+EntitlementId+'&supplierName='+supplierName);
          navigate(0)
          
        } catch (error) {      
          SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
         
        }
        }
      };

      //#region OnWheel Prevent Change
    const numberInputOnWheelPreventChange = (e) => {
      // Prevent the input value change
      e.target.blur()
    
      // Prevent the page/container scrolling
      e.stopPropagation()
    
      // Refocus immediately, on the next tick (after the current function is done)
      setTimeout(() => {
        e.target.focus()
      }, 0)
    }
    //#endregion
    return (
        <>
         <KhAlert Kh_Active={alert_.Activate} msg={alert_.msg} func_setactive={SetAlert} />
            <div className='parent-Dmaterial'>
                <div className='child-Dmaterial'>
                
            <div className="mb-3"> 
              <label className="form-label">
              قيمة الدفعة
              </label>
              <input
                className="form-control"
                type="number"
                name="amountPayment"
                value={formData.amountPayment}
                onChange={(e)=>{handleChange('amountPayment',e.target.value)}}
                onWheel={numberInputOnWheelPreventChange}
							/>
              {formData.amountPayment<0.01 &&flag&& ( <p className="validationReg"> *الرجاء تحديد قيمة الدفعة</p>)}
            </div>
           
            <div className="mb-3">
              <label className="form-label">
                التاريخ
              </label>
              <input
                className="form-control"
                type="date"
                name="paymentDate"
                value={formData.paymentDate}
                onChange={(e)=>{handleChange('paymentDate',e.target.value)}}
              />
               {formData.paymentDate.length<1 &&flag&& ( <p className="validationReg"> *الرجاء تحديد التاريخ</p>)}
            </div>
            <div className="mb-3">
                <label className="form-label">
                ملاحظات
                </label>
                <textarea 
                type='text'
                className="form-control"
                name="notes" 
                value={formData.notes} 
                onChange={(e)=>{handleChange('notes',e.target.value)}}
                placeholder={"إضافة ملاحظات..."}               
                />
              
            </div>
       
        <button className='btn-Add' onClick={()=>{handleSubmit()}} >إضافة</button>
                </div>
            </div>
            
        </>
    );
}

export default AddPayment;
